<template>
	<div>
		<div class="ui button" @click="cancel">Cancel</div>
		<div class="ui primary button" @click="save">Save</div>
	</div>
</template>

<script>
export default {
	methods: {
		cancel: function() {
			window.returnToMainTab();
		},
		save: function() {
			this.$emit('save');
		}
	}
};
</script>